<template>
    <heading-section title="中学生ピクトリンク無料サービス"/>
</template>

<script>
import HeadingSection from "../atoms/HeadingSection.vue";
export default {
    name: "JhsFreeHeading",
    components: {HeadingSection},
}
</script>
